import { isArray } from "lodash";
import {
    setErrorRequest,
    setErrorRequestRespStatus,
    setSuccessRequest,
} from "./Request";

const getMessage = (err) => {
    return err.response && err.response.data.message
        ? err.response.data.message
        : err.message;
};

export const RequestResultFunction = async (
    dispatch,
    apiFunc,
    type,
    payload = null
) => {
    try {
        const { data } = await apiFunc;

        if (data.error !== undefined) {
            if (!data.error) {
                if (isArray(type)) {
                    //type ile birden fazla dispatch fonksiyonu gonderilebilir
                    type.forEach((element) => {
                        dispatchFunc(element, payload, data, dispatch);
                    });
                } else {
                    dispatchFunc(type, payload, data, dispatch);
                }

                if (data.message && data.message !== "") {
                    dispatch(setSuccessRequest(data.message));
                }
            } else {
                dispatch(setErrorRequest(data.message));
            }
        } else {
            dispatch(
                setErrorRequestRespStatus(
                    getMessage(data),
                    data.response.status
                )
            );
        }
    } catch (err) {
        try {
            dispatch(
                setErrorRequestRespStatus(getMessage(err), err.response.status)
            );
        } catch (error) {
            console.log("test error.message", error.message);
        }
    }
};

const dispatchFunc = (type, payload, data, dispatch) => {
    let obj = {};
    obj.type = type;
    if (payload !== null) {
        obj.payload = payload;
    } else {
        obj.payload = data.result;
    }
    dispatch(obj);
};

export const getFormData = (user) => {
    const form_data = new FormData();

    Object.keys(user).forEach((element) => {
        if (typeof user[element] === "object") {
            if (user[element].lastModifiedDate) {
                form_data.append(element, user[element]);
            } else {
                form_data.append(element, JSON.stringify(user[element]));
            }
        } else if (typeof user[element] === "boolean") {
            form_data.append(element, user[element] ? 1 : 0);
        } else {
            form_data.append(element, user[element]);
        }
    });

    return form_data;
};
